import React from "react";
import FormativeAssessment from "./FormativeAssessment";
import { useLaunchParams } from "./shared/useLaunchParams";
import MissingChapter from "./shared/MissingChapter";

/** LTI route wrapper for the formative assessment flow. */
const FormativeAssessmentPage: React.FC = () => {
  const { chapterId, tier, lang, role, studentAssignmentId } = useLaunchParams();
  if (!chapterId) return <MissingChapter screen="formative" lang={lang} />;
  return <FormativeAssessment chapterId={chapterId} tier={tier} lang={lang} role={role} studentAssignmentId={studentAssignmentId} />;
};

export default FormativeAssessmentPage;
